import React, { CSSProperties, FC } from 'react';
import classNames from 'classnames';

import { AppColoredBoxProps } from './interfaces';

import useStyles from './style';

const AppColoredBox: FC<AppColoredBoxProps> = ({ className, color }) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(classes.colorBox, className, {
        withColor: !!color,
      })}
      style={
        {
          '--box-clr': color,
        } as CSSProperties
      }
    />
  );
};

export default AppColoredBox;
